<template>
  <el-drawer
    title="自提订单核销"
    :visible.sync="visible"
    @close="comStateClose"
    size="800px"
    :close-on-press-escape="false"
    id="comDrawe"
    :modal-append-to-body="false"
  >
    <div class="drawerView">
      <div class="drawerCom">
        <div class="drawerComL">录入核销码：</div>
        <div class="drawerComR">
          <el-input
            v-model="pick_up_store_code"
            placeholder="请输入核销码"
            style="width: 224px;"
            @keyup.enter.native="handelComClick"
          ></el-input>
        </div>
      </div>
      <div class="drawerViewT" v-if="tableData!=''">
        <div class="drawerCom">
          <div class="drawerComL">用户：</div>
          <div class="drawerComR">{{user_info.nick_name}}</div>
        </div>
        <div class="drawerCom">
          <div class="drawerComL">电话：</div>
          <div class="drawerComR">{{user_info.user_mobile }}</div>
        </div>
        <div class="drawerCom">
          <div class="drawerComL">下单日期：</div>
          <div class="drawerComR">{{ $public.FTime(tableData.create_time, "YYYY-MM-DD HH:mm:ss") }}</div>
        </div>
        <div class="drawerCom">
          <div class="drawerComL">订单编号：</div>
          <div class="drawerComR">{{tableData.no}}</div>
        </div>
        <div class="drawerCom">
          <div class="drawerComL">订单金额：</div>
          <div class="drawerComR">{{ tableData.total_price }}</div>
        </div>
        <div class="tableBox" style="margin: 0 20px;">
          <el-table :data="goodList" style="width: 80%;height: 100%;">
            <el-table-column prop="goods_name" label="商品"></el-table-column>
            <el-table-column prop="sku_value" label="规格"></el-table-column>
            <el-table-column prop="unit" label="单位"></el-table-column>
            <el-table-column prop="num" label="数量"></el-table-column>
          </el-table>
        </div>
        <div class="drawerViewB">
          <div class="btn2" @click="comStateClose">取消</div>
          <div class="btn" @click="handleSunmitClick">确定</div>
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      visible: true,
      tableData: [],
      user_info: [],
      goodList: [],
      pick_up_store_code: ""
    };
  },
  watch: {
    // 监视状态发生改变
    comState() {
      this.visible = this.comState;
    }
  },
  mounted() {},
  methods: {
    handelComClick() {
      this.getTableData();
    },
    getTableData() {
      let params = {
        pick_up_store_code: this.pick_up_store_code
      };
      this.$http
        .get(
          process.env.VUE_APP_Url_order +
            "/api/OffLineOrder/get/pick_up_store_code",
          params
        )
        .then(res => {
          if (res.code == 0) {
            this.tableData = res.data;
            this.user_info = res.data.user_info;
            this.goodList = [];
            this.tableData.order_item_list.map(item => {
              this.goodList.push({
                goods_name: item.goods_name,
                sku_value: item.sku_value,
                unit: item.unit,
                num: item.num
              });
            });
          }
        });
    },
    handleSunmitClick() {
      let params = {
        order_id: this.tableData._id
      };
      this.$http
        .get(
          process.env.VUE_APP_Url_order + "/api/OffLineOrder/havegood",
          params
        )
        .then(res => {
          if (res.code == 0) {
            console.log(res, "确认收货");
            this.$message({
              type: "success",
              message: "已收货"
            });
            this.$emit("closeOn", {
              type: "submit"
            });
          }
        });
    },
    comStateClose() {
      this.$emit("closeOn", { type: "close" });
    }
  }
};
</script>

<style lang="scss" scoped>
.drawerView {
  height: 100%;
  display: flex;
  flex-direction: column;

  .drawerViewT {
    flex: 1;
    box-sizing: border-box;
    border-top: solid 1px #f2f2f2;
    overflow-y: scroll;
  }
  .drawerCom {
    display: flex;
    margin-top: 32px;
    align-items: center;

    .drawerComL {
      width: 132px;
      margin-right: 22px;
      font-size: 14px;
      color: #343440;
      text-align: center;
      line-height: 20px;
      margin-top: 12px;
    }

    .drawerComR {
      flex: 1;

      .avatar-uploader .el-upload {
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }

      .avatar-uploader .el-upload:hover {
        border-color: #409eff;
      }

      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 128px;
        height: 128px;
        line-height: 128px;
        text-align: center;
        background: #f0f0f7;
        border: 1px dashed #b0b0bf;
        border-radius: 8px;
        box-sizing: border-box;
      }

      .avatar {
        width: 128px;
        height: 128px;
        display: block;
        object-fit: cover;
      }

      .drawerSelect {
        display: flex;
        flex: 1;
        flex-wrap: wrap;

        .drawerSelectItem {
          width: 128px;
          height: 44px;
          box-sizing: border-box;
          font-size: 14px;
          color: #69697b;
          text-align: center;
          line-height: 44px;
          position: relative;
          background: #fafafd;
          border-radius: 8px;
          margin-right: 16px;
          margin-bottom: 10px;

          div:nth-of-type(1) {
            position: absolute;
            left: 16px;
            top: 0;
            bottom: 0;
            margin: auto 0;
            width: 16px;
            height: 16px;
            border-radius: 100%;
            border: solid 1px #b0b0bf;
          }
        }

        .drawerSelectActiveItem {
          width: 128px;
          height: 44px;
          box-sizing: border-box;
          font-size: 14px;
          color: #577bff;
          text-align: center;
          line-height: 44px;
          position: relative;
          background: #fafafd;
          border-radius: 8px;
          margin-right: 16px;
          margin-bottom: 10px;
          border: 1px solid #577bff;

          div:nth-of-type(1) {
            position: absolute;
            left: 16px;
            top: 0;
            bottom: 0;
            margin: auto 0;
            width: 4px;
            height: 4px;
            border-radius: 100%;
            border: solid 6px #577bff;
          }
        }
      }
    }
  }

  .imgItem {
    position: relative;
    margin-right: 15px;
  }

  .imgItem i {
    position: absolute;
    top: -10px;
    right: -10px;
  }

  .drawerViewT::-webkit-scrollbar {
    display: none;
  }

  .drawerViewB {
    height: 60px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 20px;
    border-top: solid 1px #f2f2f2;
    box-sizing: border-box;

    .btn {
      width: 98px;
      line-height: 40px;
      text-align: center;
      background: linear-gradient(135deg, #5685ff 0%, #3569ff 100%);
      border-radius: 10px;
      font-size: 16px;
      font-weight: bold;
      color: #fff;
      cursor: pointer;
      margin-left: 20px;
    }

    .btn2 {
      width: 98px;
      line-height: 40px;
      text-align: center;
      border-radius: 10px;
      font-size: 16px;
      font-weight: bold;
      cursor: pointer;
      box-sizing: border-box;
      border: solid 1px #577bff;
      color: #577bff;
    }
  }
}
</style>